import lang from "@/views/modules/EdRequests/language/en";

export default {
    name: "new-ed-request",
    components: {
    },
    data() {
        return {
            loading: true,
            requests: {},
            lang:[],
            error_message:{
                request_to:'',
                desc:'',
            },
            showDropdown:null,
            dom_array:[],
            process:false,
           
            allFiles:[],
            fileName: [],
            fileUpload: false,
            file_error:'',
        }
    },
    computed: {
     
    },
    mounted() {
        this.getRequest();
        this.lang = lang;
        this.dom_array = this.domArrayVariable;
    },
    methods: {
        saveTicket() {
            const self = this;
            self.loading = true;
           
            let fileName = self.fileName;
        
          //  if(fileName !='' || self.requests.doc_name !=''){
                self.process = true;
                let formData = new FormData();                
                formData.append('file', self.allFiles);  // Add your form data
                self.requests.filelist = self.allFiles;
            if(self.file_error == ''){
                axios.put('api/modules/edrequests/'+self.$route.params.id, self.requests, formData, {headers: { 'Content-Type': 'multipart/form-data' }}).then(function (response) {
                    self.loading = false;
                    self.process = false;
                    self.$router.push('/modules/edrequests');
                }).catch(function () {
                    self.loading = false;
                    self.process = false;
                    let allerror = document.getElementsByClassName('error');
                    for(let i = 0; i < allerror.length; i++)
                    {
                        allerror[i].innerHTML = '';
                    }
                    let err = localStorage.getItem('Errors');
                    let err_msg = (JSON.parse(err));
                    let err_msg2 = err_msg && err_msg.errors ? err_msg.errors : {};
                    Object.keys(err_msg2 || {}).forEach((key) => {
                        let errorval = err_msg2[key];                      
                        let error_el = document.getElementById(key+"_error");
                            error_el.innerHTML = errorval
                    });
                    localStorage.removeItem('Errors');
                });
            }
           
        },
        
        changeFile(e) {
            let filelist = e.target.files;
            for(let i = 0; i < filelist.length; i++){
                let image = e.target.files[i];
                // ----------------------------
                // FILE NAME VALIDATION
                // ----------------------------
                const MAX_FILE_NAME_LENGTH = 40;

                if (image.name.length > MAX_FILE_NAME_LENGTH) {
                    alert(`File name cannot exceed ${MAX_FILE_NAME_LENGTH} characters.`);
                    e.target.value = '';
                    this.allFiles = [];
                    return;
                }
                let fileArr = [];
                let file_type_arr = e.target.files[i].type.split("/");
                this.fileName = file_type_arr;
                this.showFileName = image.name;
                // Get the file size
                let fileSize = image.size; // in bytes

                let setSize = window.app.max_file_size;
                let definedSize = 2097152;
                if(setSize[1] == 'M')
                {
                    definedSize = ((parseInt(setSize.slice(0,-1)) * 1024) * 1024); ///let  bytes = megabytes * 1024 * 1024;
                }
                if(setSize[1] == 'G')
                {
                    definedSize = (((parseInt(setSize.slice(0,-1)) * 1024) * 1024) * 1024); ///let  bytes = megabytes * 1024 * 1024;
                }
                if(fileSize <= definedSize)
                {
                let reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                //  this.file_content = e.target.result;
                    this.fileUpload = true;
                    fileArr.push(e.target.result, this.fileUpload, file_type_arr[1], image.name);
                    this.allFiles.push(fileArr);
                    }; 
                }else{
                    this.file_error = "The file size exceeds the maximum limit. Allowed file max size is "+ setSize;
                }
            }
        },

        openComponent(routeName, moduleName, field_id, queryData = null) {
            this.field_id = field_id;
            this.windowRef = window.open(`/popup?module=${routeName}&body=modal&callback=parentMethod&moduleName=${moduleName}`, "", "width=600,height=400,left=200,top=200");
            this.parentCompnent = routeName;
            this.windowRef.addEventListener('beforeunload', this.parentMethod);

        },
        parentMethod() {
            const module_name = this.parentCompnent.slice(0, -1);
            const parent_id = localStorage.getItem('parentid');
            const parent_name = localStorage.getItem('parentname');
            const parent_type = localStorage.getItem('parenttype');
            this.selectElement(module_name, parent_name, parent_id, parent_type);

            if (this.windowRef) {
                this.windowRef.close();
                this.windowRef = null;
                this.$emit('close');
            }
            localStorage.removeItem('parentid');
            localStorage.removeItem('parentname');
            localStorage.removeItem('parenttype');

        },
        updateItem(id, name, type) {
            this.showDropdown = false;
            const module_name = type;
            this.selectElement(module_name, name, id, type);
        },
        selectElement(moduleName, name = null, id = null, module = null) {

            const module_name = moduleName.replace("-", "_");
            const p_name = module_name + '_name';
            const p_name_el = document.getElementById(p_name);
           
            p_name_el.value = name;
            p_name_el.dispatchEvent(new Event('input'));
            const p_id = module_name + '_id';
            const p_id_el = document.getElementById(p_id);
            p_id_el.value = id;
            p_id_el.dispatchEvent(new Event('input'));
            //this.field_id = null;

        },
        clearComponent(modulesLink) {
            const self = this;
            self.dropdownList = [];
            if (self.dropdownList.length == 0) {
                self.selectElement(modulesLink, '', '', '');
            }
        },
        queryForKeywords(e, modulesLink, field_id) {
            const self = this;
            self.field_id = field_id;
            let searchData = e.target.value;
            let relatedModule = modulesLink + 's';
            self.showDropdown = null;

            if (searchData.length > 0) {
                axios.post(`api/modules/searchItem`, { 'data': searchData, 'relatedModule': relatedModule }).then(function (response) {
                    self.dropdownList = response.data;
                    self.showDropdown = field_id;
                });
            } else {
                self.showDropdown = false;
                self.dropdownList = [];

                if (searchData.length == 0) {
                    self.selectElement(modulesLink, '', '', '');
                }

            }
        },
        getRequest(){
            const self = this;

             window.currentAction = 'list';
                axios.get('api/modules/edrequests/'+self.$route.params.id).then(function(response){
                self.requests = response.data;
                self.requests.user_name = response.data.assigned_user;
                self.enableFileUpload(true);
               // console.log(self.requests);
            }).catch(function () {
                self.loading = false;
            });
        },
    }
}
